/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.resizeSliderTray = function() {
  const width = $('.survey-slide').length * $('.flex-viewport').width();
  if (width > 0) { return $('.slides').width(width); }
};

root.sliderStart = function() {
  setTimeout(resizeSliderTray, window.DISABLE_ANIMATIONS ? 0 : 10);
  return setTimeout((() => $('.survey-slide:last-child').css('float', 'right')), window.DISABLE_ANIMATIONS ? 0 : 1000);
};

// MVP-4561: a post the server rejects as a stale session (the voter's session
// expired, so the request now belongs to a different guest) renders
// session_expired.js.haml, which calls this with the notice's path; a Devise
// timeout 401 that never reaches the controller calls it with none. Without a
// path, use the one the slider carries on its .slides element (only on surveys
// that guard against stale sessions), read lazily because this module
// initialises before the DOM. Once navigating, queued posts are dropped.
let redirectingToSessionExpired = false;
root.redirectToSessionExpired = function(path) {
  path = path || $('.flexslider .slides').data('session-expired-path');
  if (!path) { return false; }
  redirectingToSessionExpired = true;
  window.location.href = path;
  return true;
};

// Item-viewed and survey-complete posts run one at a time, in the order the
// slides were reached, so a later post can never overtake an earlier one. The
// chain moves on after any failure, and the timeout keeps a hung request from
// holding it for the life of the page (a timed-out post is simply dropped). The
// JS a post renders (viewed.js.haml, session_expired.js.haml) is still evaluated
// by jQuery. `sessionExpiredRedirect` tells util.js's global ajaxError handler
// that a 401 is handled here.
const SURVEY_EVENT_TIMEOUT_MS = 15000;
let surveyEventChain = Promise.resolve();
const postSurveyEvent = function(path, onSuccess) {
  surveyEventChain = surveyEventChain.then(() => new Promise(function(resolve) {
    if (redirectingToSessionExpired) { return resolve(); }
    $.ajax({ type: 'POST', url: path, data: { format: 'js' }, timeout: SURVEY_EVENT_TIMEOUT_MS, sessionExpiredRedirect: true })
      .done(onSuccess)
      .fail(function(xhr) {
        if (xhr.status === 401) { redirectToSessionExpired() || location.reload(); }
      })
      .always(() => resolve());
  }));
  return surveyEventChain;
};

// A slide the carousel has moved past is still in the document, just clipped by
// the viewport, so hiding it from assistive tech with aria-hidden is only half
// the job: its inputs and buttons stay in the tab order, and a keyboard user
// tabs into controls nobody can see and no screen reader announces (axe:
// aria-hidden-focus). `inert` takes them out of the tab order as well, and is
// set and cleared in lockstep with aria-hidden so the two can never disagree.
const syncSlideVisibility = function(slider, activeSlide) {
  slider.find('.survey-slide').each(function() {
    const hidden = this !== activeSlide;
    this.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    if (hidden) {
      this.setAttribute('inert', '');
    } else {
      this.removeAttribute('inert');
    }
  });
};

// `activeIndex` indexes flexslider's slide set (`slider.slides`), which
// initFlexSlider's `selector:` limits to `.slides > .survey-slide`. Resolve the
// active element from that same set and compare by identity, so the index and
// the element can never refer to different slides.
const updateSlideAriaHidden = function(slider, activeIndex) {
  syncSlideVisibility(slider, slider.slides ? slider.slides.get(activeIndex) : null);
};

root.skipToNext = function() {
  const slider = $('.flexslider:visible').first();
  slider.flexslider("next");
};

root.confirmSkip = function(button) {
  const $button = $(button);
  const form = $button.closest('form');
  // Compare against defaultValue (the server-rendered initial value), not just non-blank,
  // so a pre-filled-but-untouched field (a signed-in respondent revisiting an already-answered
  // question) doesn't trigger a false "you typed something" warning.
  const hasUnsavedText = form.find('input[type="text"]:not(:disabled), textarea:not(:disabled)').toArray()
    .some(field => field.value.trim().length > 0 && field.value !== field.defaultValue);

  if (hasUnsavedText && !window.confirm($button.data('skip-warning'))) {
    return;
  }

  skipToNext();
};

// Navigates to the real last slide — the thank-you, or the guest sign-up after
// it — unlike skipEndIndex, which stops at the last question because that is as
// far as disabling should reach.
root.skipToEnd = function() {
  const slider = $('.flexslider:visible').first();
  const lastIndex = slider.find(".survey-slide").length - 1;
  slider.flexslider(lastIndex);
};

// Surveys::Option::SKIP_TO_END. The anonymous skipped/disabled partials
// interpolate it straight into their Next button, so it reaches the browser as
// the string '-1'; other callers pass the number. Compare as a string so both
// forms are recognised — a sentinel mistaken for an element id looks up
// `$('#-1')`, finds nothing, and used to leave the respondent on a broken
// end-of-survey screen.
const SKIP_TO_END = '-1';

const isSkipToEnd = function(id) {
  return String(id) === SKIP_TO_END;
};

root.skipToItem = function(id) {
  if (isSkipToEnd(id)) { return skipToEnd(); }

  const slide = $('#' + id);
  const slider = slide.closest('.flexslider');
  const index = slider.find(".survey-slide").index(slide);
  // A target that is neither the sentinel nor one of the slides gives -1, and
  // flexslider's .eq(-1) would treat that as the last slide: the respondent
  // lands on the thank-you screen at the wrong height with the tray shifted the
  // wrong way. Move forward one instead of stranding them there.
  if (index < 0) { return skipToNext(); }
  slider.flexslider(index);
};

root.disableChildInputs = function(parent, disabled) {
  parent.find('input').prop("disabled", disabled);
  parent.find('select').prop("disabled", disabled);
  parent.find('textarea').prop("disabled", disabled);
  const buttons = parent.find('.button');
  buttons.prop("disabled", disabled);
  return buttons.toggleClass('disabled', disabled);
};

root.disableSliderForm = function(id) {
  const slide = $("#" + id);
  return disableChildInputs(slide, true);
};

// Where a skip stops, as an exclusive index into `all`.
//
// The skip-to-end sentinel means "past the last question", not "past the last
// slide": only the survey's own items carry data-path, and the pre/post slides
// around them (thank-you, guest sign-up, demo intro) are chrome. They hold live
// controls of their own — intro/_congrats.html.haml has a real Next <button> —
// so sweeping them into the range disables the way out of the survey.
//
// endId is blank rather than absent whenever an anonymous response carries no
// skip at all, and $('#') is a jQuery syntax error rather than an empty set, so
// that selector must never be built.
const skipEndIndex = function(all, endId) {
  if (isSkipToEnd(endId)) {
    const lastItem = all.filter('[data-path]').last();
    return lastItem.length ? all.index(lastItem) + 1 : -1;
  }
  return endId ? all.index($('#' + endId)) : -1;
};

// Resolves a skip into the slide that was answered and the slides passed over,
// as indices into the slider's own .survey-slide collection. `to` is exclusive:
// the destination is the question the respondent is being sent to, so it has to
// stay answerable.
const skipRange = function(startId, endId) {
  const answered = $('#' + startId);
  const all = answered.closest('.flexslider').find('.survey-slide');
  const from = all.index(answered);
  const to = skipEndIndex(all, endId);
  if (from < 0 || to < 0 || from === to) { return { answered, skipped: [] }; }

  const step = from < to ? 1 : -1;
  const skipped = [];
  for (let i = from + step; i !== to; i += step) {
    skipped.push($(all.get(i)));
  }
  return { answered, skipped };
};

root.disableSliderPages = function(startId, endId) {
  const range = skipRange(startId, endId);

  disableChildInputs(range.answered, true);
  return range.skipped.forEach(function(slide) {
    disableChildInputs(slide, true);
  });
};

root.updateSliderStatus = function(startId, endId, statusMsg, skippedMsg) {
  setTimeout((function() {
    const range = skipRange(startId, endId);
    range.answered.find('.status').html(statusMsg);
    range.answered.find('form input[type="submit"]').hide();

    range.skipped.forEach(function(slide) {
      slide.find('.status').html(skippedMsg);
      slide.find('form input[type="submit"]').hide();
      slide.find('.content-item-next').html(skippedMsg);
    });

    return $(window).trigger('resize');
  }), window.DISABLE_ANIMATIONS ? 0 : 1500);
};

root.initSliderBullets = function(slider) {
  if (slider.find('.flex-control-nav').length) {
    const defaultSize = 20;
    const defaultOuterSize = defaultSize * 2;
    const nav = slider.find('.flex-control-nav');
    const bullets = slider.find('.flex-control-nav>li');
    const count = bullets.length;
    const last = bullets.last();
    const prev = slider.find('.flex-prev');
    const dirNavWidth = prev.outerWidth(true) * 2;
    const outerX = (nav.width() - dirNavWidth) / (count + 2);
    let x = outerX / 2; //margin(left + right) = bullet width
    x = Math.min(x, defaultSize);
    nav.find('li a').css({
      width: x,
      height: x
    });
    nav.find('li').css({
      width: x,
      'margin-left': x / 2,
      'margin-right': x / 2,
      'margin-top': (prev.height() - x) / 2
    });
  }
};

root.initSliderDirNav = function(slider) {
  if (slider.find('.flex-control-nav li').length) {
    const sliderWidth = slider.width();
    const bulletsLeft = slider.find('.flex-control-nav li').first().offset().left;
    const last = slider.find('.flex-control-nav li').last();
    //use 1/2 bullet width as margin for directionals
    const margin = last.width() / 2;
    const bulletsRight = last.offset().left + last.width();
    const dirNav = slider.find('.flex-direction-nav');
    const parentLeft = dirNav.offset().left;
    const parentRight = parentLeft + dirNav.width();
    const prev = slider.find('.flex-prev');
    prev.css({
      left: bulletsLeft - margin - prev.width() - parentLeft});
    const next = slider.find('.flex-next');
    next.css({
      right: parentRight - bulletsRight - margin - prev.width()});
  }
};

root.checkSliderNavVisibility = function() {
  if ($('.mod-intro-survey').length) {
    const first = $('.survey-slide:first-of-type');
    const active = $('.flex-active-slide');
    if (first.length && active.length && (first[0] !== active[0])) {
      return $('.mod-intro-survey .flex-direction-nav, .mod-intro-survey .flex-control-nav').fadeIn('slow');
    }
  }
};

root.initSliderNav = function() {
  checkSliderNavVisibility();
  if ($('.flexslider').length) {
    const sliders = $(".flexslider");
    $.each(sliders, function(index, flexslider) {
      const slider = $(flexslider);
      initSliderBullets(slider);
      return initSliderDirNav(slider);
    });
  }
};

const countDecimals = function(_s) {
  const s = _s.toString().replace(/[^0-9.]/g,'');
  if (s.indexOf(".") >= 0) {
    return s.length - s.indexOf(".") - 1;
  } else {
    return 0;
  }
};

const roundTo = function(num, decimals) {
  const multiplier = Math.pow(10, decimals);
  const r = (Math.round(num * multiplier) / multiplier).toFixed(decimals);
  return r;
};

root.initChooseNForm = function(form) {
  const chooseN = form.find('.choose-n');
  const total = parseInt(chooseN.data('max-selections'));
  const $remaining = chooseN.find('.remainder .remainder-value');
  const submit = form.find("input[type='submit']");
  let invalidTimer = null;

  return form.find("input[type='checkbox']").off('change.chooseN').on('change.chooseN', function() {
    const overflow = form.find("input[type='checkbox']:checked").length - total;

    if (overflow > 0) {
      // Uncheck this box first, then uncheck any remaining overflow left over
      // from rapid clicks that batched multiple DOM changes before any event fired.
      $(this).prop('checked', false);
      form.find("input[type='checkbox']:checked").slice(total).prop('checked', false);

      if (invalidTimer !== null) clearTimeout(invalidTimer);
      $remaining.addClass('invalid').removeClass('valid');
      invalidTimer = setTimeout(function() {
        $remaining.addClass('valid').removeClass('invalid');
        invalidTimer = null;
      }, window.DISABLE_ANIMATIONS ? 0 : 200);
    } else {
      if (invalidTimer !== null) {
        clearTimeout(invalidTimer);
        invalidTimer = null;
      }
      $remaining.addClass('valid').removeClass('invalid');
    }

    $remaining.text(total - form.find("input[type='checkbox']:checked").length);
  });
};

root.initAllocateForm = function(form) {
  let remainingVal;
  const allocate = form.find('.allocate');
  const total = (remainingVal = parseInt(allocate.data('allocation-total')));
  const $remaining = allocate.find('.remainder .remainder-value');
  const submit = form.find("input[type='submit']");
  let invalid = false;

  allocate.find('.allocation input:enabled').each(function(i) {
    const obj = $(this);
    const val = obj.val();
    i = (val === '') ? 0 : parseInt(val.match(/^\d*$/));
    if (isNaN(i)) {
      obj.addClass('invalid');
      return invalid = true;
    } else if ((i < 0) || (i > total)) {
      obj.addClass('invalid');
      invalid = true;
      return remainingVal -= i;
    } else {
      obj.removeClass('invalid');
      return remainingVal -= i;
    }
  });

  $remaining.text(remainingVal);
  if (remainingVal === 0) {
    $remaining.addClass('complete').removeClass('invalid');
  } else if ((remainingVal < 0) || (remainingVal > total)) {
    $remaining.addClass('invalid').removeClass('complete');
    invalid = true;
  } else {
    $remaining.removeClass('invalid complete');
    invalid = true;
  }

  return submit.prop('disabled', invalid);
};

root.initBudgetForm = function(form) {
  const budget = form.find('.budget');
  const _total = budget.data('allocation-total');

  if (_total !== undefined) {
    form.find("input[type='checkbox']").change(() => updateBudgetForm(form, _total));
  }
};

root.updateBudgetForm = function(form) {
  const invalid = false;
  const budget = form.find('.budget');
  const _total = budget.data('allocation-total');

  if (_total !== undefined) {
    const total = parseFloat(_total);
    const totalDecimals = countDecimals(_total);
    const symbol = budget.data('symbol');

    const submit = form.find("input[type='submit']");
    const $remaining = budget.find('.remainder .remainder-value');

    let remainingBudget = total;
    let decimals = totalDecimals;

    if (form.find("input[type='checkbox']:checked").length) {
      form.find("input[type='checkbox']:checked").each(function(i) {
        const $budgetItem = $(this);
        const _cost = $budgetItem.data('cost');
        decimals = Math.max(decimals, countDecimals(_cost));
        const cost = parseFloat(_cost);
        return remainingBudget = remainingBudget - cost;
      });


      const roundedVal = roundTo(remainingBudget, decimals);
      if (remainingBudget >= 0) {
        $remaining.text(symbol + roundedVal);
        $remaining.removeClass('invalid');
        submit.prop('disabled', false);

        return true;
      } else {
        $remaining.addClass('invalid');
        $remaining.text('-' + symbol + Math.abs(roundedVal));
        submit.prop('disabled', true);

        return false;
      }
    } else {
      return $remaining.text(symbol + budget.data('allocation-total'));
    }
  }
};

root.selectRadio = function(radioInput) {
  const form = radioInput.closest('form');
  form.find('input[type="radio"]').prop('checked', false);
  form.find('.button.selected').removeClass('selected');
  radioInput.prop('checked', true);
  const button = radioInput.parents('.button');
  button.addClass('selected');
};

// `control` is the option's <button>: the option-a / option-b card buttons, or
// the inner button of the option-nil wrapper. The selected state + aria-pressed
// live on that button, and the radio sharing its data-id carries the form value.
root.selectBinaryOption = function(control) {
  if (control.hasClass('disabled') || control.is('[disabled]')) return;
  const binary = control.closest('.binary');
  binary.find('.option-a, .option-b, .option-nil .button')
    .removeClass('selected').attr('aria-pressed', 'false');
  binary.find('input[type="radio"]').prop('checked', false);
  control.addClass('selected').attr('aria-pressed', 'true');
  binary.find('input[type="radio"][value="' + control.attr('data-id') + '"]').prop('checked', true);
  submitForm(control);
};

root.disableForm = form => disableChildInputs(form, true);

root.enableForm = form => disableChildInputs(form, false);

root.submitForm = function(element) {
  const $form = element.closest('form');
  if ($form.data('submitting')) return;
  $form.data('submitting', true);
  // Prefer Rails UJS if available
  if (window.Rails && typeof Rails.fire === 'function') {
    Rails.fire($form[0], 'submit');
  } else {
    // Fallback: jQuery submit event (still runs UJS handlers if present)
    $form.trigger('submit');
  }
};

root.startAtIndex = function(slider, id) {
  if (id === undefined) {
    return 0;
  } else if (isSkipToEnd(id)) {
    return slider.find('.survey-slide').length - 1;
  } else {
    const index = slider.find('.survey-slide').index(slider.find('#' + id));
    return index >= 0 ? index : 0;
  }
};

root.checkSlidePosition = function() {
  const slider = $('#survey-slider');
  const _left = slider.offset().left + parseInt(slider.css('border-left-width'));
  const active = slider.find('.flex-active-slide');
  if (active && (active.offset().left !== _left)) {
    active.offset({ left: _left });
    return slider.redraw();
  }
};

// The tray is as wide as every slide combined, so its overflow:hidden viewport
// has a scrollable overflow area the carousel knows nothing about. Anything that
// scrolls it sideways — focus landing in an off-screen slide, tabbing into a
// later question's controls, find-in-page — moves the pixels without moving the
// carousel, so flexslider ends up rendering one slide at another slide's height.
// The viewport is never meant to scroll horizontally: put it back when it does.
// Scoped to the survey slider — initFlexSlider runs over every .flexslider on
// the page, and a slider that legitimately scrolls its viewport shouldn't have
// this fighting it.
root.pinViewportScroll = function(slider) {
  if (!slider.is('#survey-slider, .survey-slider')) { return; }

  return slider.find('.flex-viewport')
    .off('scroll.surveySlider')
    .on('scroll.surveySlider', function() {
      if (this.scrollLeft !== 0) { this.scrollLeft = 0; }
    });
};

root.resizeSlider = function(slider) {
  slider.data('flexslider').resize();
  return setTimeout(resizeSliderTray, window.DISABLE_ANIMATIONS ? 0 : 10);
};

root.initFlexSlider = function() {
  if (!$('.flexslider').length) { return; }

  $('.flexslider').each(function(i) {
    const $flexslider = $(this);
    const startAtId = $flexslider.find('.slides').data('start-at');
    const startAt = startAtIndex($flexslider, startAtId);

    return $flexslider.flexslider({
      animation: window.DISABLE_ANIMATIONS ? null : "slide",
      animationSpeed: window.DISABLE_ANIMATIONS ? 0 : 600,
      animationLoop: false,
      selector: ".slides > .survey-slide",
      slideshow: false,
      touch: false,
      keyboard: false,
      smoothHeight: true,
      startAt,

      start(slider) {
        sliderStart();
        pinViewportScroll(slider);
        const slide = slider.find('.flex-active-slide');
        // The server renders aria-hidden from the slide it expects to open on,
        // and some injected pre/post slides carry no hint at all. Restate it
        // from the slide flexslider actually landed on, so the very first
        // keyboard tab cannot reach a slide that is already off screen.
        // When the selector matches no slides, flexslider calls start() without
        // building a slider, so there is no active slide — and syncing to
        // nothing would hide and inert every slide.
        if (slide.length) { syncSlideVisibility(slider, slide[0]); }
        const path = slide.data('path');
        if (path) { return postSurveyEvent(path, () => slide.data('path', null)); }
      },

      before(slider) {
        // before() fires synchronously at the start of every transition —
        // arrows, bullets, and programmatic flexslider(index) calls alike — so
        // it is the single source of truth for syncing aria-hidden to the
        // destination slide. (after() is unreliable: it hangs off animation
        // completion, which never fires when animations are disabled.)
        // `animatingTo` is already set to the target index at this point, and
        // flexslider clamps it in range, so this also avoids the old
        // skipToNext edge case where currentSlide + 1 could overflow.
        updateSlideAriaHidden(slider, slider.animatingTo);
        if (slider[0].getBoundingClientRect().top <= 0) { return slider[0].scrollIntoView(); }
      },

      after(slider) {
        const slide = slider.find('.flex-active-slide');
        const path = slide.data('path');
        if (path) { postSurveyEvent(path, () => slide.data('path', null)); }
        // Announce the new question to screen readers by moving focus to its
        // counter heading — but only on a genuine slide change. Foundation text
        // inputs (the open-question field) transition box-shadow on focus; that
        // transitionend bubbles up to the slides container, where flexslider's
        // handler mistakes it for the slide animation ending and re-runs
        // after() — stealing focus from the field back to the heading (notably
        // under JAWS when arrowing into the open input). Skip when focus is
        // already inside the active slide.
        const active = document.activeElement;
        if (active && $.contains(slide[0], active)) { return; }
        // preventScroll matters: after() hangs off animation completion but can
        // fire while the tray is still moving, so the destination slide is not
        // reliably on screen here. A plain focus() on a slide that is still
        // off-screen scrolls the overflow:hidden viewport sideways instead of
        // moving the carousel, which leaves flexslider's transform and height
        // on one slide while the pixels show another.
        const counter = slide.find('.sr-question-counter').first()[0];
        if (counter) { counter.focus({ preventScroll: true }); }
      },

      end(slider) {
        const slides = $('.flexslider .slides');
        const path = slides.data('path');
        if (path) { postSurveyEvent(path, () => slides.data('path', null)); }
        if ($('#signup-form').length) { return $("#signup-form").find('#user_email').select(); }
      }
    });
  });

  initSliderNav();
  return $(window).resize(() => initSliderNav());
};

root.initContentSlider = function() {
  if (!$('#content-slider').length) { return; }

  $('#content-slider').flexslider({
      animation: window.DISABLE_ANIMATIONS ? null : "slide",
      animationSpeed: window.DISABLE_ANIMATIONS ? 0 : 600,
      slideshowSpeed: 5000,
      slideshow: true,
      touch: true,
      keyboard: true,
      pauseOnAction: false
  });

  initContentSlider();
  return $(window).resize(() => initContentSlider());
};

root.skipToStart = function() {
  $(document).off('click.go-beg');
  return $(document).on('click.go-beg', '#go-to-start', function() {
    const slider = $('.flexslider:visible').first();
    return slider.flexslider(0);
  });
};

root.initSurveyControls = function() {
  $('.allocate').each(function(i) {
    const obj = $(this);
    return initAllocateForm(obj.closest('form'));
  });

  $('.budget').each(function(i) {
    const form = $(this).parents('form');
    initBudgetForm(form);
    return updateBudgetForm(form);
  });

  $('.choose-n, .choose-n-open').each(function(i) {
    const obj = $(this);
    return initChooseNForm(obj.closest('form'));
  });

  $(document)
  .off('click.surveySliderRating', ".rating-options .rating-option")
  .on('click.surveySliderRating', ".rating-options .rating-option", function(e) {
    const obj = $(this);
    if (obj.hasClass('disabled')) return;
    obj.closest('.rating-options').find('.rating-option')
      .removeClass('selected').attr('aria-pressed', 'false');
    obj.addClass('selected').attr('aria-pressed', 'true');
    const form = obj.closest('form');
    $("input[name$='[integer]']", form).val(obj.find('.rating-value').text());
    submitForm(obj);
    e.preventDefault();
    e.stopPropagation();
  });

  $(document)
  .off('click.matrixRatingOption', ".matrix-options .rating-option")
  .on('click.matrixRatingOption', ".matrix-options .rating-option", function() {
    const obj = $(this);
    if (obj.hasClass('disabled')) { return; }
    const option = obj.parents('tr');
    option.find('.rating-option').removeClass('selected');
    obj.addClass('selected');
    const value = obj.data('value');
    option.find('.option input[type="hidden"]').val(value);
  });

  $(document)
  .off('click.matrixRating', ".matrix-rating")
  .on('click.matrixRating', ".matrix-rating", function() {
    const obj = $(this);
    if (!obj.hasClass('disabled')) { return obj.find('input[type="radio"]').click(); }
  });

  $(document)
  .off('click.matrixRatingInput', ".matrix-rating input[type='radio']")
  .on('click.matrixRatingInput', ".matrix-rating input[type='radio']", function(e) {
    e.stopPropagation();
  });

  $(document)
  .off('click.chooseOneInput', ".choose-one .option .button input[type='radio']")
  .on('click.chooseOneInput', ".choose-one .option .button input[type='radio']", function(e) {
    const radio = $(this);
    selectRadio(radio);
    if (!radio.data("open_question")) { submitForm(radio); }
    e.stopPropagation();
  });

  $(document)
  .off('click.chooseOneButton', ".choose-one .option .button")
  .on('click.chooseOneButton', ".choose-one .option .button", function(e) {
    if ($(e.target).is('input')) return;
    const input = $(this).find('input[type="radio"]');
    selectRadio(input);
    if (!input.data("open_question")) { submitForm(input); }
    e.stopPropagation();
    e.preventDefault();
  });

  $(document)
  .off('click.chooseMultipleButton', ".choose-multiple .option .button")
  .on('click.chooseMultipleButton', ".choose-multiple .option .button", function(e) {
    if ($(e.target).is('input')) return;
    const input = $(this).find('input[type="checkbox"]');
    input.prop('checked', !input.prop('checked')).trigger('change');
    e.stopPropagation();
    e.preventDefault();
  });

  $(document)
  .off('click.chooseMultipleInput', ".choose-multiple .option .button input")
  .on('click.chooseMultipleInput', ".choose-multiple .option .button input", function(e) {
    e.stopPropagation();
  });

  $(document)
  .off('click.binaryButton', ".binary .option-a, .binary .option-b, .binary .option-nil .button")
  .on('click.binaryButton', ".binary .option-a, .binary .option-b, .binary .option-nil .button", function(e) {
    // Let the "more info" link open its modal without recording a vote.
    if ($(e.target).closest('.more-info').length) return;
    selectBinaryOption($(this));
    e.stopPropagation();
    e.preventDefault();
  });

  $(".allocate .option .allocation input").keyup(function(e) {
    const obj = $(this);
    initAllocateForm(obj.closest('form'));
  });

  $(".flex-direction-nav .flex-prev").click(function(e) {
    const prev = $(this);
    const surveyId = prev.closest('.flexslider').find('ul.slides').data('survey');
    track('Survey', 'Navigated In Survey', 'prev:' + surveyId.toString());
  });

  $(".flex-direction-nav .flex-next").click(function(e) {
    const next = $(this);
    const surveyId = next.closest('.flexslider').find('ul.slides').data('survey');
    track('Survey', 'Navigated In Survey', 'next:' + surveyId.toString());
  });

  $(".flex-control-nav li a").click(function(e) {
    const page = $(this);
    const pageNum = page.text();
    const surveyId = page.closest('.flexslider').find('ul.slides').data('survey');
    track('Survey', 'Navigated In Survey', 'page-' + pageNum + ':' + surveyId.toString());
  });

  // aria-describedby also names the open-text warning (MVP-4550), so the error
  // id is added and removed as one token rather than replacing the attribute.
  function setDescribedBy($input, id, present) {
    const ids = ($input.attr('aria-describedby') || '').split(/\s+/).filter(t => t && t !== id);
    if (present) ids.unshift(id);
    if (ids.length) {
      $input.attr('aria-describedby', ids.join(' '));
    } else {
      $input.removeAttr('aria-describedby');
    }
  }

  // Open questions require a non-blank response. Catch this on ajax:before - the
  // earliest cancellable rails-ujs hook - so the request is abandoned before
  // ajax:beforeSend fires and disableForm() runs.
  $(document)
  .off('ajax:before.openResponseRequired', 'form.new_user_response, form.edit_user_response')
  .on('ajax:before.openResponseRequired', 'form.new_user_response, form.edit_user_response', function(e) {
    const $form = $(this);
    const $input = $form.find('.open-question-input');
    if (!$input.length) return;

    const $errorMessage = $form.find('.open-response-required-error');
    if ($input.val().trim().length === 0) {
      $errorMessage.removeClass('hidden');
      $input.attr('aria-invalid', 'true');
      setDescribedBy($input, $errorMessage.attr('id'), true);
      // The single-line variant submits on Enter while already focused, so
      // focus() alone is a no-op there and the new aria-describedby would
      // never be announced. Blur first so focus() is a genuine focus change.
      if (document.activeElement === $input[0]) $input.blur();
      $input.focus();
      e.preventDefault();
      return;
    }

    $errorMessage.addClass('hidden');
    $input.removeAttr('aria-invalid');
    setDescribedBy($input, $errorMessage.attr('id'), false);
  });

  $(document)
  .off('ajax:beforeSend.surveySlider', 'form.new_user_response, form.edit_user_response')
  .on('ajax:beforeSend.surveySlider', 'form.new_user_response, form.edit_user_response', function() {
    disableForm($(this));
    $(this).find('.alert-error').remove();
  });

  $(document)
  .off('input.openResponseRequired', '.open-question-input')
  .on('input.openResponseRequired', '.open-question-input', function() {
    const $input = $(this);
    if ($input.val().trim().length === 0) return;
    const $errorMessage = $input.closest('form').find('.open-response-required-error');
    $errorMessage.addClass('hidden');
    $input.removeAttr('aria-invalid');
    setDescribedBy($input, $errorMessage.attr('id'), false);
  });

  $(document)
  .off('ajax:complete.surveySlider', 'form.new_user_response, form.edit_user_response')
  .on('ajax:complete.surveySlider', 'form.new_user_response, form.edit_user_response', function() {
    $(this).removeData('submitting');
    if (window.DISABLE_ANIMATIONS) {
      return enableForm($(this));
    } else {
      const form = $(this);
      return setTimeout((() => enableForm(form)), 1000);
    }
  });

  $(document)
  .off('ajax:error.surveySlider', 'form.new_user_response, form.edit_user_response')
  .on('ajax:error.surveySlider', 'form.new_user_response, form.edit_user_response', function(e) {
    // rails-ujs puts [response, statusText, xhr] in the CustomEvent's detail.
    const detail = e.originalEvent && e.originalEvent.detail;
    const xhr = detail && detail[2];
    if (xhr && xhr.status === 401 && redirectToSessionExpired()) { return; }
    $('#unable-to-save-error').show();
  });

  $(window).keydown(function(e) {
    const keyCode = e.keyCode || e.which;
    if (keyCode === 9) {
      const activeObj = document.activeElement;
      const form = $(activeObj).closest('form');
      const last = form.find('input, select, option, a, textarea, button').last();

      if ($('.survey-slider').length && (!form.length || (activeObj === last[0]))) {
        return e.preventDefault();
      }
    }
  });

  return $(window).keyup(function(e) {
    const keyCode = e.keyCode || e.which;
    if ((keyCode === 9) && $('.flexslider').find('input:focus').length) { checkSlidePosition(); }
  });
};

/*
$(function() {
  if ($('#content-slider').length) {
    initContentSlider();
    $(window).resize(function() {
      if ($(window).width() !== root.window_width) {
        root.window_width = $(window).width();
        return $('.flexslider').each(function(i) {
          return resizeSlider($(this));
        });
      }
    });
  }

  if ($('#survey-slider').length) {
    initFlexSlider();
    initSurveyControls();
    skipToStart();
    root.window_width = $(window).width();
    return $(window).resize(function() {
      if ($(window).width() !== root.window_width) {
        root.window_width = $(window).width();
        return $('.flexslider').each(function(i) {
          return resizeSlider($(this));
        });
      }
    });
  }
});
*/

function initSliderOnLoad() {

  if ($('#content-slider').length) {
    initContentSlider();
    $(window).resize(function() {
      if ($(window).width() !== root.window_width) {
        root.window_width = $(window).width();
        return $('.flexslider').each(function(i) {
          return resizeSlider($(this));
        });
      }
    });
  }

  if ($('#survey-slider').length) {
    initFlexSlider();
    initSurveyControls();
    skipToStart();
    root.window_width = $(window).width();
    return $(window).resize(function() {
      if ($(window).width() !== root.window_width) {
        root.window_width = $(window).width();
        return $('.flexslider').each(function(i) {
          return resizeSlider($(this));
        });
      }
    });
  }  

}

$(initSliderOnLoad);
document.addEventListener('turbo:load', initSliderOnLoad);
